import { InformationCircleIcon } from "@heroicons/react/24/outline";
import dayjs from "dayjs";
import type { StatsViewModel } from "../utils/statsViewModel";

/**
 * The blue info banner shared by the two detail views. `kind` comes straight
 * from the {@link StatsViewModel}: `"empty"` (no data for the range) replaces
 * the content, `"stale"` (data only available until `staleUntil`) sits above
 * it, `"none"` renders nothing.
 */
export function StatsBanner({
  kind,
  staleUntil,
}: {
  kind: StatsViewModel["banner"];
  staleUntil?: string | null;
}) {
  if (kind === "none") return null;

  const message =
    kind === "empty"
      ? "Keine Daten für angefragten Zeitraum gefunden"
      : `Die Daten sind nur bis zum ${dayjs(staleUntil).format(
          "DD.MM.YYYY"
        )} verfügbar`;

  return (
    <div className="rounded-md bg-blue-50 p-4 mb-4">
      <div className="flex">
        <div className="shrink-0">
          <InformationCircleIcon
            aria-hidden="true"
            className="h-5 w-5 text-blue-400"
          />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-blue-700">{message}</p>
        </div>
      </div>
    </div>
  );
}
